import { Mesh, SphereGeometry } from 'three';
import type { MaterialFactory } from './types';
import { WORLD } from '../core/config';

export function createSkyDome(materials: MaterialFactory): Mesh {
  const geometry = new SphereGeometry(WORLD.skyRadius, 32, 16);
  const material = materials.sky();

  const mesh = new Mesh(geometry, material);
  mesh.renderOrder = 1000;
  mesh.frustumCulled = false;

  return mesh;
}
